import { useRouter } from 'vue-router'

export function useAdminApi() {
  const router = useRouter()

  const token = () => localStorage.getItem('adminToken') ?? ''

  const apiFetch = async (path: string, options: RequestInit = {}): Promise<Response> => {
    const res = await fetch(`/api${path}`, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token()}`,
        ...(options.headers ?? {}),
      },
    })
    if (res.status === 401) {
      localStorage.removeItem('adminToken')
      router.push('/login')
      throw new Error('Unauthorized')
    }
    return res
  }

  const logout = () => {
    localStorage.removeItem('adminToken')
    router.push('/login')
  }

  const formatDate = (d: string) => new Date(d).toLocaleDateString()

  return { apiFetch, logout, formatDate }
}

/**
 * Resolve a stored S3 key to a servable media URL. Library photos live under
 * library/… in the images bucket and are served at that path by the CDN.
 * Returns '' for an empty key (safe to bind to :src — renders nothing).
 */
export function photoUrl(key?: string | null): string {
  return key ? '/' + key.replace(/^\/+/, '') : ''
}

/** Parse a fetch Response as JSON, tolerating an empty/invalid body. */
export async function jsonOf(res: Response): Promise<any> {
  try { return await res.json() } catch { return {} }
}
